import { Button, FormControl, IconButton, TableCell, Typography, withStyles } from "@material-ui/core"
import React from 'react'
// import styled from "styled-components"

const SubmitButton = withStyles(theme => ({
  root: {
    background: props => props.bg ? props.bg : '#ff314a',
    color: props => props.color ? props.color : '#fff',
    border: `1px solid ${props => props.bg ? props.bg : '#ff314a'}`,
    minWidth: 120,

    [theme.breakpoints.down('sm')]: {
      minWidth: 1,
      fontSize: 12,
    },

    '&:hover': {
      background: props => props.hover ? props.hover : '#e42d42',
    },

    '&:disabled': {
      color: '#ccc',
      background: '#f5f5f5',
      border: '1px solid #ccc'
    },

    height: 54,
  }
}))(Button)

const BackButton = withStyles({
  root: {
    background: '#fff',
    color: '#ff314a',
    fontWeight: 'bold',
    border: `2px solid #ff314a`,
    minWidth: 120,
  }
})(Button)

const InputLabs = withStyles({
  root: {
    background: '#1c242f',
    borderRadius: 10,

    '& input, svg, label': {
      color: '#fff',
    },

    '& label': {
      '&.Mui-focused': {
        color: '#fff'
      }
    },

    '&:hover div fieldset': {
      border: '1px solid transparent !important'
    },

    '& div fieldset': {
      borderRadius: 10,
      border: '1px solid transparent !important',
    },

    '& div.Mui-focused fieldset': {
      borderColor: '#fff !important'
    }
  }
})(FormControl)

const TableCellHead = withStyles(theme => ({
  root: {
    background: '#ff314a',
    color: '#fff',
    fontWeight: 'bold',

    '& p': {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
    },

    '& .btn_ordination': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      cursor: 'pointer',

      '& svg': {
        position: 'relative',

        '&:first-child': {
          top: 7,
        },

        '&:last-child': {
          bottom: 7,
        }
      }
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    }
  }
}))(TableCell)


const IconUpdate = withStyles({
  root: {
    color: 'orange'
  }
})(IconButton)

const IconDelete = withStyles({
  root: {
    color: '#f4393c'
  }
})(IconButton)

const TitleTable = withStyles((theme) => ({
  root: {
    color: '#ff314a',
    margin: 0,
    fontSize: 32,

    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }

  }
}))(Typography)

const Santolabs = withStyles((theme) => ({
  root: {
    '& span': {
      fontFamily: 'courier !important',
      color: '#fff',
      fontSize: props => props.fontSize ? props.fontSize : 20,

      '&:first-child': {
        color: '#e63246',
        fontWeight: 'bold',
      },

      '&:last-child': {
        fontSize: props => props.fontSize ? (props.fontSize - 10) : 15,
      }
    }
  }
}))(Typography)

const InputCustom = withStyles(() => ({
  root: {
    '& .MuiOutlinedInput-inputAdornedStart': {
      paddingLeft: 15
    },

    '& .MuiFormLabel-root.Mui-focused': {
      color: '#000'
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: 10,

      '&.Mui-focused': {
        '& fieldset': {
          borderColor: '#000',
        },
      },
    },

  }
}))(FormControl)

const IconShell = (props) => {
  return (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 511.965 511.965"
      height="512" viewBox="0 0 511.965 511.965"
      width="512" xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <ellipse cx="389.949" cy="341.545" rx="39.871" ry="39.871" transform="matrix(.967 -.257 .257 .967 -74.549 111.425)" />
        <ellipse cx="327.62" cy="142.34" rx="27.465" ry="27.465" transform="matrix(.822 -.57 .57 .822 -22.705 212.113)" />
        <path d="m501.609 167.471c-15.493-58.034-45.394-95.72-84.195-106.116-26.58-7.121-56.572-.893-86.738 18.014-23.331 14.624-45.99 36.182-66.13 62.814-1.357-2.534-2.738-5.041-4.156-7.502-29.984-52.046-68.62-80.709-108.79-80.709s-78.807 28.663-108.791 80.709c-26.806 46.528-42.809 106.424-42.809 160.222 0 52.355 15.384 95.045 44.488 123.455 26.55 25.916 63.588 39.614 107.111 39.614 40.705 0 75.735-11.984 101.82-34.736 16.634 12.7 36.582 22.23 59.431 28.353 15.963 4.277 31.528 6.405 46.475 6.404 24.417-.001 47.171-5.681 67.24-16.946 35.466-19.908 61.374-57.162 74.925-107.733 13.924-51.966 13.968-113.963.119-165.843zm-481.609 127.432c0-12.08.869-24.489 2.523-36.974h258.152c1.654 12.485 2.523 24.894 2.523 36.974 0 21.638-2.693 41.03-8.027 58.096h-247.144c-5.334-17.066-8.027-36.458-8.027-58.096zm5.834-56.974c2.186-11.012 4.963-21.977 8.28-32.729 10.186 14.946 32.458 14.746 42.302-.623l15.974-24.94c5.065-7.908 16.619-7.908 21.683 0l15.974 24.94c9.981 15.583 32.749 15.583 42.73 0l15.974-24.94c5.065-7.908 16.618-7.908 21.683 0l15.974 24.94c9.927 15.499 32.497 15.576 42.561.246 3.369 10.873 6.184 21.966 8.396 33.106zm125.766-163.957c31.772 0 64.602 25.035 90.32 68.755h-180.64c25.717-43.72 58.547-68.755 90.32-68.755zm-93.142 330.074c-9.082-8.866-16.563-19.235-22.442-31.047h231.166c-5.879 11.812-13.359 22.182-22.442 31.047-22.738 22.194-54.945 33.926-93.141 33.926-38.195 0-70.403-11.732-93.141-33.926zm423.714-75.91c-12.297 45.894-34.3 78.014-65.396 95.47-20.592 11.559-44.743 16.176-70.933 13.73.838-1.686 1.539-3.468 2.045-5.357 4.112-15.346-4.995-31.121-20.342-35.233-15.346-4.112-31.121 4.995-35.233 20.342-.506 1.889-.79 3.783-.907 5.662-8.663-3.977-16.639-8.633-23.887-13.945 23.384-28.056 35.68-67.115 35.68-113.902 0-9.19-.478-18.56-1.386-28.008 3.989 3.795 8.956 6.676 14.648 8.201 18.174 4.87 36.855-5.916 41.725-24.09s-5.916-36.855-24.09-41.725c-15.578-4.174-31.519 3.159-38.825 16.782-4.891-21.887-11.929-43.464-20.806-63.538 20.166-28.545 43.21-51.402 66.834-66.209 25.335-15.879 49.867-21.288 70.939-15.642 26.249 7.033 48.511 31.95 62.867 69.602-25.539-5.929-51.366 9.416-58.204 34.935-6.983 26.06 8.482 52.847 34.543 59.829 14.37 3.851 28.954.867 40.322-6.948 1.127 30.727-2.066 61.948-9.594 90.044z" />
        <circle cx="151.599" cy="305.464" r="18.914" />
        <circle cx="67.35" cy="305.464" r="18.914" />
        <circle cx="235.849" cy="305.464" r="18.914" />
      </g>
    </svg>
  )
}

const IconPackage = (props) => {
  return (
    <>
      <svg
        fill='#fff'
        height="27"
        viewBox="0 0 512 512"
        width="27"
        xmlns="http://www.w3.org/2000/svg">
        <path d="m467.58 104.84-192-96a8.018 8.018 0 0 0 -6.93-.1l-208 96a7.978 7.978 0 0 0 -4.65 7.26v288a7.978 7.978 0 0 0 4.65 7.26l208 96a8 8 0 0 0 6.93-.1l192-96a8.011 8.011 0 0 0 4.42-7.16v-288a8.011 8.011 0 0 0 -4.42-7.16zm-112.2-38.21-171.04 92.1-43.82-20.22 175.79-91.41zm-179.38 105.87v127.37l-40-17.15v-128.68zm95.86-147.62 26.77 13.38-174.32 90.64a8.37 8.37 0 0 0 -1.81 1.29l-39.41-18.19zm-7.86 458.62-192-88.62v-270.38l48 22.16v141.34a8 8 0 0 0 4.85 7.35l56 24a7.866 7.866 0 0 0 3.15.65 8 8 0 0 0 8-8v-132.11l72 33.23zm7.86-284.38-69.35-32 170.37-91.74 73.23 36.62zm184.14 195.94-176 88v-270.12l176-88z" />
      </svg>
    </>
  )
}

const IconGoal = (props) => {
  return (
    <>
      <svg
        id="Capa_1"
        fill='#fff'
        enable-background="new 0 0 512 512"
        height="25"
        viewBox="0 0 512 512"
        width="25" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="m109.894 154.876-18.894 18.891-4.394-4.393c-5.857-5.858-15.355-5.858-21.213 0-5.858 5.857-5.858 15.353 0 21.21l15 14.998c5.857 5.857 15.355 5.858 21.213 0l29.5-29.497c5.858-5.857 5.858-15.353 0-21.21-5.857-5.857-15.355-5.857-21.212.001z" /><path d="m166 195.978h90c8.284 0 15-6.715 15-14.998s-6.716-14.998-15-14.998h-90c-8.284 0-15 6.715-15 14.998s6.716 14.998 15 14.998z" /><path d="m109.894 245.866-18.894 18.891-4.394-4.393c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.354 0 21.21l15 14.998c5.859 5.858 15.355 5.857 21.213 0l29.5-29.497c5.858-5.857 5.858-15.353 0-21.21-5.857-5.857-15.355-5.857-21.212.001z" /><path d="m109.894 335.445-18.894 18.892-4.394-4.393c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.354 0 21.21l15 14.998c5.859 5.858 15.355 5.857 21.213 0l29.5-29.497c5.858-5.857 5.858-15.354 0-21.21-5.857-5.856-15.355-5.856-21.212 0z" /><path d="m501.745 243.759-35.312-11.769-11.77-35.308c-3.519-10.556-16.954-13.744-24.837-5.862l-42.404 42.399c-18.295-7.706-37.27-11.302-56.422-11.239v-130.99h30c8.284 0 15-6.715 15-14.998v-22.998c0-29.221-23.776-52.994-53-52.994h-270c-29.224 0-53 23.773-53 52.994v413.953c0 8.283 6.716 14.998 15 14.998h228.242c94.606 72.728 233.208 5.324 233.208-114.987 0-19.452-3.786-38.242-11.246-55.967l42.403-42.398c7.87-7.867 4.713-21.309-5.862-24.834zm-170.295 173.194c-27.57 0-50-22.427-50-49.994 0-37.608 40.101-61.59 73.106-44.314l-33.713 33.709c-5.858 5.857-5.858 15.354 0 21.21 5.858 5.858 15.355 5.857 21.213 0l33.713-33.709c17.228 32.904-6.616 73.098-44.319 73.098zm-8.449-386.956c12.682 0 23 10.317 23 22.997v7.999h-240.001c-.382-4.861 1.714-16.588-5.255-30.996zm-293.001 22.997c0-12.681 10.318-22.997 23-22.997s23 10.317 23 22.997v22.997c0 8.283 6.716 14.998 15 14.998h210v134.212c-23.522 5.046-44.943 15.813-62.733 30.77h-72.267c-8.284 0-15 6.715-15 14.998s6.716 14.998 15 14.998h45.237c-11.848 17.526-19.962 37.771-23.204 59.583h-22.033c-8.284 0-15 6.715-15 14.998s6.716 14.998 15 14.998h20.711c1.67 28.428 11.567 54.677 27.341 76.401h-184.052c0-17.65 0-380.006 0-398.953zm301.45 428.951c-63.411 0-115-51.583-115-114.987 0-81.029 82.06-136.62 156.95-107.07l10.98 32.936-7.994 7.993c-52.291-35.631-124.936 1.436-124.936 66.142 0 44.107 35.888 79.991 80 79.991 64.484 0 101.911-72.452 66.149-124.922l7.993-7.993 32.93 10.976c29.633 75.129-26.235 156.934-107.072 156.934zm108.467-188.09-26.517-8.838-8.839-26.513 29.316-29.313 6.467 19.399c1.493 4.478 5.008 7.993 9.487 9.485l19.401 6.467z" />
        </g>
      </svg>
    </>
  )
}

export {
  SubmitButton,
  InputLabs,
  BackButton,
  TableCellHead,
  IconDelete,
  IconUpdate,
  TitleTable,
  Santolabs,
  IconShell,
  IconPackage,
  IconGoal,
  InputCustom
}
